import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=a3a4fd80"
import script from "./PageFooter.js?vue&type=script&lang=js&external"
export * from "./PageFooter.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports